module.exports = __webpack_public_path__ + "img/03.6204a6e0.jpg";